import { DOM } from '../../modules/settings'
import animations from '../../modules/animations'

export default class Apply {
  constructor() {
    if (!DOM.apply) return

    animations.apply()
  }
}